import { InjectionToken } from '@angular/core';

export const urlConstants = {
  SURVEY_RESULTS: '/api/v4/cir/score',
};

export type URLConstants = typeof urlConstants;

export const urlConstantsToken = new InjectionToken<URLConstants>(
  'urlConstantsToken'
);
